import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { lazyTriggerLocationsChangedEvent } from 'owa-addins-core';

export default function triggerLocationsChanged() {
    const calendarEvent = getComposeStore().event;
    lazyTriggerLocationsChangedEvent
        .import()
        .then(triggerLocationsChangedEvent =>
            triggerLocationsChangedEvent(calendarEvent.ParentFolderId.Id, calendarEvent.Locations)
        );
}
